import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import NewPage from "../../../layouts/page/NewPage";
import Form from "./Form";
import MenuConfig from "../../../../constants/MenuConfig";
import Api from "../../../../constants/Api";
import { getId, sendToApi } from "../../../../utils/ApiUtils";
import { convertBooleanToStatus } from "../../../../utils/ConverterUtils";
import { formatDateToYYYYMMDD } from "../../../../utils/DateUtils";
import { ApiError } from "../../../components/Common/ApiError";

const PotBonusRuleNew = () => {

    const { t } = useTranslation();
    const [status, setStatus] = useState(true);
    const [entityData, setEntityData] = useState(null);
    const navigate = useNavigate();

    const initialValues = {
        employee: null,
        percent: '',
        description: '',
        validFrom: new Date(),
        validTo: null
    };

    const formSchema = Yup.object().shape({
        employee: Yup.object().nullable().required(t('validation.custom.pot.bonus.employee.required')),
        // Zero não é acordo nenhum, e acima de 100 pagaria mais do que a empresa tem no pote.
        percent: Yup.number()
            .typeError(t('validation.custom.pot.bonus.percent.invalid'))
            .moreThan(0, t('validation.custom.pot.bonus.percent.invalid'))
            .max(100, t('validation.custom.pot.bonus.percent.invalid'))
            .required(t('validation.custom.pot.bonus.percent.invalid')),
        validFrom: Yup.date().nullable().required(t('validation.required.validFrom')),
        // Fim em branco significa acordo por prazo indeterminado; informado, não pode ser
        // anterior ao início, senão o acordo nunca valeria.
        validTo: Yup.date().nullable().min(
            Yup.ref('validFrom'),
            t('validation.custom.pot.bonus.period.invalid')
        )
    });

    function onReset() {
        formik.resetForm({ values: initialValues });
        setStatus(true);
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: formSchema,
        onSubmit: values => {
            let payload = {
                id: getId(entityData),
                employee: values.employee ? { id: values.employee.value } : null,
                percent: values.percent,
                description: values.description,
                validFrom: values.validFrom ? formatDateToYYYYMMDD(values.validFrom) : null,
                validTo: values.validTo ? formatDateToYYYYMMDD(values.validTo) : null,
                status: convertBooleanToStatus(status)
            }

            sendToApi(Api.gamification.pot_bonus_rule, payload, () => {
                if (entityData == null) {
                    onReset();
                } else {
                    navigate(MenuConfig.gamification.pot_bonus_rule.route);
                }
            }, (error) => {
                // Sobreposição de vigência e estouro da parte da empresa são barrados no
                // backend, único lugar com acesso a todos os acordos já gravados.
                ApiError(error);
                formik.setSubmitting(false);
            });
        },
    });

    const onSubmit = (e) => {
        e.preventDefault();
        formik.handleSubmit();
    }

    return (
        <>
            <NewPage
                motherMenu={t('gamification.pot')}
                childMenu={t('pot_bonus_rules')}
                activeMenu={t('new')}
                child={<Form formik={formik} status={status} setStatus={setStatus} entityData={entityData} />}
                setEntityData={setEntityData}
                path={Api.gamification.pot_bonus_rule}
                isSubmitting={formik.isSubmitting}
                handleSubmit={onSubmit}
                cancelRoute={MenuConfig.gamification.pot_bonus_rule.route}
            />
        </>
    );
}

export default PotBonusRuleNew;
